import { useState } from 'react';
import { Link, useParams, useSearchParams } from 'react-router-dom';
import { LockKeyhole, RefreshCw } from 'lucide-react';
import { Btn, Loading } from '../components/shared';
import { passportMedia, passportTabs, usePlayerPassport } from '../lib/playerPassport';
import { PlayerPassportHeader } from '../components/player-passport/Header';
import { Overview } from '../components/player-passport/Overview';
import { Development } from '../components/player-passport/Development';
import { Metrics } from '../components/player-passport/Metrics';
import { Trainers } from '../components/player-passport/Trainers';
import { Links } from '../components/player-passport/Links';
import { Sharing } from '../components/player-passport/Sharing';
import { BaseballDetails } from '../components/player-passport/BaseballDetails';
import { PassportEmpty } from '../components/player-passport/Primitives';
import '../styles/player-passport.css';
import '../styles/passport-refresh.css';
import { PassportTabs } from '../components/player-passport/PassportTabs';

export default function PlayerPassport({ invitationToken }) {
  const { id } = useParams();
  const [params, setParams] = useSearchParams();
  const [modal, setModal] = useState(null);
  const endpoint = invitationToken ? `/player-passports/invitations/${invitationToken}` : `/player-passports/${id}`;
  const { data, error, load } = usePlayerPassport(endpoint);
  const key = params.get('tab') || 'overview';
  const tab = passportTabs.map(name => name.toLowerCase()).includes(key) ? key : 'overview';
  const selectTab = value => { setParams({ tab: value }); load(); };
  if (error) return <div className="pp-scope player-passport"><PassportEmpty id="pp-load-error" title="This Passport is unavailable." icon={LockKeyhole}>{error}</PassportEmpty><div className="pp-error-actions"><Btn secondary data-testid="pp-retry" onClick={load}><RefreshCw />Try again</Btn>{!invitationToken && <Link data-testid="pp-error-back" to="/parent">Return to your players</Link>}</div></div>;
  if (!data) return <Loading />;
  const mediaUrl = passportMedia(endpoint);
  const { athlete, permissions } = data;
  return <div className="pp-scope player-passport passport-refresh" data-testid="player-passport">
    <PlayerPassportHeader athlete={athlete} owner={permissions.can_manage} mediaUrl={mediaUrl} onShare={() => setModal('share')} onEdit={() => setModal('baseball')} />
    <PassportTabs tab={tab} onSelect={selectTab} />
    <section className="pp-tab-panel" role="tabpanel" id={`pp-panel-${tab}`} aria-labelledby={`pp-tab-${tab}`} data-testid={`pp-panel-${tab}`}>
      {tab === 'overview' && <Overview data={data} mediaUrl={mediaUrl} onTab={selectTab} onLinksChanged={load} />}
      {tab === 'development' && <Development goals={data.goals} />}
      {tab === 'metrics' && <Metrics evaluations={data.evaluations} canViewScores={permissions.can_view_scores} />}
      {tab === 'trainers' && <Trainers trainers={data.trainers} mediaUrl={mediaUrl} />}
      {tab === 'links' && <Links athleteId={athlete.id} links={data.links} canManage={permissions.can_manage} onChange={load} />}
    </section>
    <footer className="pp-footer" data-testid="pp-footer"><LockKeyhole size={13} />ONE ATHLETE. EVERY CHAPTER.</footer>
    {permissions.can_manage && modal === 'share' && <Sharing athlete={athlete} onClose={() => setModal(null)} />}
    {permissions.can_manage && modal === 'baseball' && <BaseballDetails athlete={athlete} onClose={() => setModal(null)} onSaved={load} />}
  </div>;
}